// NotFound.tsx
import React from 'react';

const NotFound = () => {
  return <div>
        <h1 className='d-flex align-items-center justify-content-center' style={{ minHeight: '60vh' }}>404 Not Found</h1>
    </div>;
};

export default NotFound;